import vueAPI from "@/modules/vueAPI.js"

let thisMenuControl = {
    state: {
        selectedPage: 'dashboardMenu',
        selectedPageDisplayName: 'Dashboard',
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
}

let pageList = []
pageList.push({
    name:'dashboardMenu',
    displayName:'Dashboard',
})
pageList.push({
    name:'usersMenu',
    displayName:'Employees',
})
pageList.push({
    name:'suppliersMenu',
    displayName:'Suppliers',
})
pageList.push({
    name:'partnersMenu',
    displayName:'Partners',
})
pageList.push({
    name:'clientsMenu',
    displayName:'Clients',
})
pageList.push({
    name:'productsMenu',
    displayName:'Products',
})
pageList.push({
    name:'categoriesMenu',
    displayName:'Categories',
})
pageList.push({
    name:'labelsMenu',
    displayName:'Labels',
})
pageList.push({
    name:'invoicesMenu',
    displayName:'Invoices',
})
pageList.push({
    name:'financesMenu',
    displayName:'Finances',
})
pageList.push({
    name:'discountsMenu',
    displayName:'Discounts',
})
pageList.push({
    name:'promoCodesMenu',
    displayName:'Promo Codes',
})
pageList.push({
    name:'deliveryMenu',
    displayName:'Delivery',
})
pageList.push({
    name:'warehouseMenu',
    displayName:'Warehouse',
})
pageList.push({
    name:'permissionsMenu',
    displayName:'Permissions',
})
pageList.push({
    name:'settingsMenu',
    displayName:'Settings',
})
pageList.push({
    name:'techDevPanel',
    displayName:'Developer Panel',
})

global.pageList = pageList

let urlData = new URLSearchParams(window.location.search)
let thisSelectedPage = urlData.get('mpage')
if (thisSelectedPage >= 0) {
    let pageListByIndex = pageList[Number(thisSelectedPage)]
    if (pageListByIndex) {
        thisMenuControl.state.selectedPage = pageListByIndex.name
        thisMenuControl.state.selectedPageDisplayName = pageListByIndex.displayName
    }
}

let selectedPageChangedDuringPopState = false
global.selectedPageChangedDuringPopState = selectedPageChangedDuringPopState

window.onpopstate = function(event) {
    // console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
    let urlData = new URLSearchParams(window.location.search)
    let thisSelectedPage = urlData.get('mpage')
    if (thisSelectedPage >= 0) {
        let pageListByIndex = pageList[Number(thisSelectedPage)]
        if (pageListByIndex) {
            selectedPageChangedDuringPopState = true
            vueAPI.onMounted(function(thisVue) {
                thisVue.$store.state.menuControl.selectedPage = pageListByIndex.name
                thisVue.$store.state.menuControl.selectedPageDisplayName = pageListByIndex.displayName
            })
        }
    }
};

export default thisMenuControl;